import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds
} from "../../Ads";
import { SERVER_URL } from "./ConstantsHealthCalculator";
import { BMI_Child_EndPoint } from "./ConstantsHealthCalculator";
import BMIChildrenTable from "./BMIChildrenTable";
import SharedHelmet from "../Helmet";

const TITLE =
  "Calcul de l'indice de masse corporelle (IMC) pour enfants - Calculateur de poids idéal";
const DESCRIPTION =
  "Calcul de l en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "calcul de l, calculatrice calcul de l, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/bmichildren/";
const apiEndpoint = `${SERVER_URL}/${BMI_Child_EndPoint}`;

function BMICalculator() {
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };

  const handleHeightChange = (event) => {
    setHeight(event.target.value);
  };

  const handleAgeChange = (event) => {
    setAge(event.target.value);
  };

  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };

  const calculateBMI = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ weight, height, age, gender }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
        setClassification(data.result.classification);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                Le calculateur d'indice de masse corporelle pour enfants est un outil utilisé pour évaluer et calculer si le poids d'un enfant est adapté à sa taille. Pour calculer l'indice de masse corporelle des enfants, ce calculateur utilise les catégories d'IMC utilisées pour les enfants et adolescents âgés de 2 à 20 ans. Le calculateur prend en compte l'âge, le sexe, la hauteur et le poids pour calculer l'indice de masse corporelle de l'enfant.
                <br />
                Ce calculateur affiche également un tableau d'indice de masse corporelle pour les enfants approuvé par l'agence nationale de santé publique aux États-Unis.
                <br />
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Indice de masse corporelle pour enfants (IMC)
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="height" className="form-label ms-2">
                      Taille
                    </label>
                  </b>
                  <input
                    type="number"
                    id="height"
                    value={height}
                    onChange={handleHeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="175"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">cm</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="weightNumber" className="form-label ms-2">
                      Poids
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weightNumber"
                    value={weight}
                    onChange={handleWeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="65"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">kg</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="age" className="form-label ms-2">
                      Âge
                    </label>
                  </b>
                  <input
                    type="number"
                    id="age"
                    value={age}
                    onChange={handleAgeChange}
                    className="form-control"
                    style={{ width: "90%" }}
                    placeholder="6"
                    min="2"
                    max="20"
                  />
                  <span style={{ marginRight: "10px" }}>
                    (entre 2 et 20 ans)
                  </span>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label>Sexe</label>
                  </b>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="gender"
                      value="male"
                      id="male"
                      checked={gender === "male"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="male">
                      Garçon
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="gender"
                      value="female"
                      id="female"
                      checked={gender === "female"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="female">
                      Fille
                    </label>
                  </div>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateBMI}
                    disabled={isLoading}
                  >
                    {isLoading ? "Chargement..." : "Calculer"}
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-7">
                <BMIChildrenTable
                  classification={classification}
                ></BMIChildrenTable>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u>Erreur :</u>
                    </b>{" "}
                    Veuillez remplir tous les champs correctement.
                  </div>
                )}
                {result && (
                  <div>
                    <h4>Résultats :</h4>
                    <hr />
                    <div className="alert alert-success">
                      <label>
                        <b>Indice de masse corporelle (IMC) : </b>
                        {result.bmi} <label>kg/m²</label>
                      </label>
                    </div>
                    <div className="alert alert-success">
                      <label>
                        <b>Classification : </b> {result.classification}
                      </label>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>IMC chez l'enfant</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Suivre la croissance de l'enfant</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BMICalculator;
